import React from "react";
import { cn } from "../../lib/cn";

/** Shared surface for light, trustworthy cards (no padding — add via component or className). */
export const cardBase =
  "rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 ease-in-out";

export const cardInteractive =
  "hover:-translate-y-1 motion-reduce:hover:translate-y-0 hover:border-teal-600 hover:shadow-lg";

export const cardInteractiveClasses = cn(cardBase, cardInteractive);

export function Card({
  as: Comp = "div",
  className,
  padding = "md",
  interactive = false,
  ...rest
}) {
  const paddingCls =
    padding === "none"
      ? ""
      : padding === "lg"
        ? "p-8"
        : "p-6";

  return (
    <Comp
      className={cn(
        cardBase,
        interactive && cardInteractive,
        paddingCls,
        className,
      )}
      {...rest}
    />
  );
}
